import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import Messages from '../../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL } from '../../../../shared/utility';
import { Companyid } from '../../../../shared/Config';
import FooterButton from '../../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../../store/actions/index';

class AddSubCategory extends Component {
    state = {
        type: 'add',
        Id: null,
        CategoryId: null,
        SubCategoryCode: '',
        SubCategoryName: '',
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.type;

        this.setState({ type });

        // Category options for the Category dropdown
        this.props.getMasterKeywordList("Ingcategory");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetInvingredientSubcategorybyid?ingredientSubCategoryId=${id}`,
                this.state.CompanyId
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tableLists !== prevProps.tableLists) {
            const SubCategory = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!SubCategory) return;

            this.setState({
                Id: SubCategory.ingredientSubCategoryId,
                CompanyId: SubCategory.companyId || this.state.CompanyId,
                CategoryId: SubCategory.categoryId || null,
                SubCategoryCode: SubCategory.categoryCode || "",
                SubCategoryName: SubCategory.subCategoryname || ""
            });
        }
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    add = () => {
        if (!this.state.CategoryId) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Category is required' });
            return;
        } else if (this.state.SubCategoryCode === null || this.state.SubCategoryCode.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Sub Category Code is required' });
            return;
        } else if (this.state.SubCategoryName === null || this.state.SubCategoryName.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Sub Category Name is required' });
            return;
        }

        var data = {
            subCategoryname: this.state.SubCategoryName,
            companyId: this.state.CompanyId,
            categoryCode: this.state.SubCategoryCode,
            categoryId: this.state.CategoryId
        }

        if (this.state.type === 'edit') {
            data.ingredientSubCategoryId = this.state.Id;
        }

        this.props.processDynamicData('invingredientSubcategory', this.state.type, data, 'res/GetInvingredientSubcategorybyid?' + Companyid);
    }

    resetData = () => {
        this.setState({
            Id: null,
            CategoryId: null,
            SubCategoryCode: '',
            SubCategoryName: '',
            touch: false
        });
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/subcategory/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let isEnabled = (this.state.touch === true);

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add SubCategory</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Category <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Category" options={this.props.Category} value={this.state.CategoryId} name="CategoryId" onChange={this.onDropdownChange} filter={true} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Sub Category Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="SubCategoryCode" placeholder="Sub Category Code" value={this.state.SubCategoryCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Sub Category Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="SubCategoryName" placeholder="Sub Category Name" value={this.state.SubCategoryName} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                            </div>
                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/subcategory/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Category: (state.keyword.Ingcategory !== undefined) ? state.keyword.Ingcategory : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddSubCategory);
